import { shallowEqual } from 'react-redux';
import {
  connectMediaStore,
  useMMSelector,
  useMMDispatchActions,
} from './withOwnReduxStore';
import { setCurrentSubfolderId, unsetCurrentSubfolderId } from '../actions';
import { getCurrentSubfolderId, getCurrentSubfolder } from '../selectors';
import { PapiGallection } from '@wix/da-papi-types';

export type WithCurrentSubfolderProps = {
  currentSubfolderId?: number;
  currentSubfolder: PapiGallection | undefined;
  setCurrentSubfolderId: (folderId: number) => void;
  unsetCurrentSubfolderId: () => void;
};

export const useCurrentSubfolder = (): WithCurrentSubfolderProps => ({
  ...useMMSelector(
    state => ({
      currentSubfolderId: getCurrentSubfolderId(state),
      currentSubfolder: getCurrentSubfolder(state),
    }),
    shallowEqual
  ),
  ...useMMDispatchActions({ setCurrentSubfolderId, unsetCurrentSubfolderId }),
});

export default connectMediaStore(
  state => ({
    currentSubfolderId: getCurrentSubfolderId(state),
    currentSubfolder: getCurrentSubfolder(state),
  }),
  {
    setCurrentSubfolderId,
    unsetCurrentSubfolderId,
  }
);
